import { t } from 'i18next';
import { ReactElement, useCallback } from 'react';
import { Button, Drawer, IconButton } from 'rsuite';
import CloseIcon from '@rsuite/icons/Close';

interface IProps {
  children: ReactElement;
  title?: string;
  emberChildren?: ReactElement;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  openEmber: boolean;
  setOpenEmber: React.Dispatch<React.SetStateAction<boolean>>;
  className?: string;
}
export const MultipleLevelDrawer = ({
  children,
  emberChildren,
  open,
  setOpen,
  openEmber,
  setOpenEmber,
  title,
  className
}: IProps) => {
  const close = useCallback(() => {
    setOpen(false);
    setOpenEmber(false);
  }, [open]);
  return (
    <>
      <Drawer
        size={'xs'}
        open={open}
        placement={'right'}
        onClose={() => close()}
        className={
          className ? className + ' multi-level-drawer' : 'multi-level-drawer'
        }
      >
        <div className={openEmber ? 'open ember-view' : 'ember-view'}>
          <Drawer.Header className=" ember-header drawer-header">
            <IconButton
              appearance="link"
              className="ember-close-btn"
              icon={<CloseIcon color="red" />}
              onClick={() => setOpenEmber(false)}
            >
              {t('common.drawerCloseButton')}
            </IconButton>
          </Drawer.Header>
          <div className="ember-body">{emberChildren}</div>
        </div>
        <Drawer.Header className="drawer-header main-header">
          <b>{title}</b>
          <IconButton
            appearance="link"
            className="main-close-btn"
            icon={<CloseIcon color="red" />}
            onClick={close}
          ></IconButton>
        </Drawer.Header>
        <Drawer.Body className="drawer-body main-body">{children}</Drawer.Body>
        <Drawer.Actions className="drawer-actions main-actions">
          <Button className="drawer-close-btn" onClick={close}>
            {t('common.drawerCloseButton')}
          </Button>
        </Drawer.Actions>
      </Drawer>
    </>
  );
};
